<template>
  <div
    :class="
      this.$Base.checkSysteam() == 'MOBILE'
        ? 'm-rastar-verified'
        : 'rastar-verified'
    "
  >
    <rastar-loading v-if="loading" />
    <iframe ref="iframe" :src="verifiedUrl"></iframe>
  </div>
</template>

<script>
import rastarLoading from "../loading/template.vue";
import { RSSign } from "../../utils/sign";

export default {
  name: "RastarVerified",
  props: ["pId", "appId", "mdId", "uinfo"],
  components: {
    rastarLoading,
  },
  data() {
    return {
      loading: true,
      verifiedUrl: "",
    };
  },
  methods: {
    getVerifiedUrl: function () {
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            let api = JSON.parse(this.$Storage.localStorageGet("api"));
            let data = {
              ts: new Date().getTime(),
              token: res.data,
              cch_id: this.pId,
              app_id: this.appId,
              md_id: this.mdId,
              device_id: this.$Storage.localStorageGet("deviceIdUa"),
              uinfo: this.uinfo,
              sdk_ver: this.$Base.sdkVer(),
              time_zone: this.$Base.timeZone(),
              sys_language: this.$Storage.localStorageGet("lang"),
              nonce: this.$Base.nonce(12),
              version: this.$Base.getVersion(),
              id_certificate_official_url: api?.user?.id_certificate_official,
              sys_type: "page",
            };
            const queryString = Object.entries(data)
              .map(
                ([key, value]) =>
                  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
              )
              .join("&");

            this.verifiedUrl =
              this.$Storage.localStorageGet("verifiedUrl") + "?" + queryString;
            this.loadiframe();
          }
        });
    },

    loadiframe: function () {
      var cs = true;
      var _this = this;
      if (this.$refs.iframe.attachEvent) {
        this.$refs.iframe.attachEvent("onload", function () {
          if (cs) {
            _this.loading = false;
            cs = false;
          }
        });
      } else {
        this.$refs.iframe.onload = function () {
          if (cs) {
            _this.loading = false;
            cs = false;
          }
        };
      }
    },

    // 监听iframe内页postmessage事件
    iframeListener: function (res) {
      let data = res.data;
      let action = data.action;
      let value = data.value;
      // 解密uinfo
      if (action === "decodeUInfo") {
        console.log(value);
        this.$refs.iframe.contentWindow.postMessage(
          {
            action: "callBackDecodeUinfo",
            value: JSON.parse(this.$Ciphertext.Decrypt(value)),
          },
          "*"
        );
      }
      // 加密uinfo
      if (action === "encodeUInfo") {
        this.$refs.iframe.contentWindow.postMessage(
          {
            action: "callBackEncodeUinfo",
            value: this.$Ciphertext.AESkey(value),
          },
          "*"
        );
      }
      // sgin 签名
      if (action === "getSign") {
        const signType = value.signType;
        if (signType) {
          // 不参与签名
          delete value.signType;
        }
        this.$refs.iframe.contentWindow.postMessage(
          {
            action: "callBackSign",
            value: { sign: RSSign(value, this.appId), signType: signType },
          },
          "*"
        );
      }
      // 完成实名验证
      if (action === "finishCertificate") {
        // 跳过
        if (value.state == 0) {
          this.$emit("finish", { type: "jump" });
        } else {
          // 完成
          this.$emit("finish", { type: "success", data: value });
        }
      }
      // 取消实名验证
      if (action === "cancelCertificate") {
        console.log(value);
        this.$emit("finish", { type: "cancel" });
      }
    },
  },
  created() {
    this.getVerifiedUrl();
  },
  mounted() {
    // 监听iframe内页postmessage事件
    window.addEventListener("message", this.iframeListener, false);
  },
};
</script>
<style lang="scss" src="../../views/index/style.scss" scoped></style>

<style lang="scss" src="./style.scss" scoped></style>
